import { Component, OnInit } from '@angular/core';
import { UtilityServicesService } from 'src/app/services/utility-service/utility-services.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/services/http/http.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Component({
  selector: 'app-test-instructions',
  templateUrl: './test-instructions.component.html',
  styleUrls: ['./test-instructions.component.scss']
})
export class TestInstructionsComponent implements OnInit {
  campaignShortName: any;
  accessTokens: string;
  showContentFlag: boolean = false;

  constructor(private utlityServices:UtilityServicesService,
    private spinnerService: Ng4LoadingSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private httpServices: HttpService) { }
 info:any;
 detail:any;
  ngOnInit() {
    this.campaignShortName = this.route.snapshot.paramMap.get('shortName');
    this.accessTokens = this.route.snapshot.paramMap.get('accesstoken');
    localStorage.setItem('token', this.accessTokens)

    let options = {
      purpose : '/users/verifytoken'
    }
    this.httpServices.getWithTokens(options).subscribe(
      response => {
        if((response as any).statusCode === 200){
         // console.log("verify otp:"+(response as any).message)
         
          if(this.accessTokens){
            localStorage.setItem("checkValue", 'true');
            this.showContentFlag = true

          }
        }
       
      },
      error => {
        
        if((error as any).error.statusCode === 404){
        this.router.navigate(['portal-link']);
      }
      }
    )
   
    this.getData();
    this.getInfo();
  }


  getData(){
    this.utlityServices.getInstruction().subscribe(data=>{
     
      this.info=data['directions'];
     

    })
  }

  getInfo(){
    this.utlityServices.getInfo().subscribe(data=>{
    
      this.detail=data['data'];
     

    })
  }

  startTest(){
    if(this.accessTokens != null || this.accessTokens != undefined)
    this.spinnerService.show()
    this.router.navigateByUrl('test');

  }

}
